import React, { useEffect, useState } from 'react';
import { Box, Grid, Tab, Tabs } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useParams } from 'react-router-dom';
import ProductCard from '../../components/Card/ProductCard';
import useStyles from './useStyles';
import { getProducts } from '../../apis/product';
import ProductSkeleton from './Skeleton';
import BoxEmpty from '../../components/Empty';
import InfoDialog from '../../components/InfoDialog';

const useStyle = makeStyles(() => ({
  root: {
    width: '100% !important',
  },
}));

function Courses() {
  return (
    <Grid container mt={2} spacing={3}>
      {[].map((item) => (
        <Grid item xl={2} lg={3} md={4} sm={6} xs={12} key={item.id}>
          <ProductCard product={item} />
        </Grid>
      ))}
    </Grid>
  );
}

function Exams() {
  const [loading, setLoading] = useState(true);
  const [examsList, setExamsList] = useState([]);
  const [selectProduct, setSelectProduct] = useState(null);
  const { shortDescription = '', productName = '' } = selectProduct || {};

  const getExamsDate = () => {
    setLoading(true);
    getProducts('0')
      .then((res) => {
        const filterProduct = res?.products.filter((i) => i.productId === 101);
        setExamsList(filterProduct || []);
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    getExamsDate();
  }, []);

  if (loading) return <ProductSkeleton />;

  if (examsList.length === 0) return <BoxEmpty />;

  return (
    <Grid container mt={2}>
      {examsList.map((item) => (
        <Grid item xl={2} lg={3} md={4} sm={6} xs={12} key={item.productId}>
          <ProductCard product={item} setSelectProduct={setSelectProduct} />
        </Grid>
      ))}

      <InfoDialog
        openInfoDialog={!!selectProduct}
        closeDialog={() => setSelectProduct(null)}
        message={shortDescription || ''}
        title={productName}
      />
    </Grid>
  );
}

const Product = () => {
  const styles = useStyle();
  const classes = useStyles();
  const { tab } = useParams();

  const [tabValue, setTabValue] = useState(0);

  const handleChange = (event, newValue) => setTabValue(newValue);

  useEffect(() => {
    if (tab) setTabValue(parseInt(tab, 10));
  }, [tab]);

  return (
    <Box className={classes.mainContainer}>
      <Tabs
        color='primary'
        classes={{ root: styles.root }}
        value={tabValue}
        onChange={handleChange}
        variant='scrollable'
        scrollButtons='auto'
        aria-label='scrollable auto tabs example'
      >
        <Tab label='تست ها' />
        <Tab label='دوره ها' disabled />
      </Tabs>
      {tabValue === 1 ? <Courses /> : <Exams />}
    </Box>
  );
};

export default Product;
